// src/features/biller/plans/useBillerPlans.ts
import { useCallback } from "react";
import { useSelector } from "react-redux";

import { useAppDispatch } from "../../../store/hooks";
import { BillerPlansPayload } from "features/bbps/biller/billerFlowTypes";
// import { billerPlansRequest, billerPlansReset } from "store/bbps/billerPlans/billerPlanActions";
import { RootState } from "store/rootReducer";
import {
  billerPlansRequested,
  billerPlansReset,
} from "store/bbps/billerPlans/billerPlanSlice";

export function useBillerPlans() {
  const dispatch = useAppDispatch();
  const state = useSelector((s: RootState) => s.billerPlans);

  const fetchPlans = useCallback(
    (payload: BillerPlansPayload) => {
      dispatch(billerPlansRequested(payload));
    },
    [dispatch],
  );

  const resetPlans = useCallback(() => {
    dispatch(billerPlansReset());
  }, [dispatch]);

  return {
    ...state, // { loading, plans, error }
    fetchPlans,
    resetPlans,
  };
}

// export function useBillerPlans() {
//   const dispatch = useAppDispatch();
//   const state = useSelector((s: RootState) => s.billerPlans);

//   const fetchPlans = useCallback(
//     (payload: BillerPlansPayload) => {
//       dispatch(billerPlansRequest(payload));
//     },
//     [dispatch]
//   );

//   const resetPlans = useCallback(() => {
//     dispatch(billerPlansReset());
//   }, [dispatch]);

//   return {
//     ...state, // { loading, plans, error }
//     fetchPlans,
//     resetPlans,
//   };
// }
